import { Flex, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  type DefaultProps,
  type Restrictions as RestrictionsType,
} from 'typings'
import { useFormStateContext } from '../../../providers'
import { useDrawerState } from '../../Drawer'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
} from '../Section'
import { Editor } from './Editor'
import { RESTRICTIONS } from './typings'
import { View } from './View'

export function Restrictions(props: DefaultProps) {
  const drawerState = useDrawerState()
  const { form: mainForm } = useFormStateContext()

  const handleRemove = (restrictionKey: keyof RestrictionsType) => {
    mainForm.setValue(`${RESTRICTIONS}.${restrictionKey}`, undefined)
  }

  return (
    <Section>
      <SectionHeader>
        <Flex direction="column" align="baseline">
          <SectionTitle>
            <FormattedMessage id="admin/promotions.form.restrictions.title" />
          </SectionTitle>
          <Text tone="secondary">
            <FormattedMessage id="admin/promotions.form.restrictions.subtitle" />
          </Text>
        </Flex>
      </SectionHeader>
      <SectionContent>
        {props.children}
        <View onEdit={drawerState.show} onRemove={handleRemove} />
        <Editor state={drawerState} />
      </SectionContent>
    </Section>
  )
}
